"use client";

import { useEffect, useRef, useState } from "react";
import type { BlogPostSummary } from "@/modules/blog/types";
import BlogPostCard from "@/app/(blog)/blog/components/BlogPostCard";

export default function InfinitePostGrid(
  props: Readonly<{ posts: ReadonlyArray<BlogPostSummary>; pageSize?: number }>
) {
  const pageSize = props.pageSize ?? 9;
  const [visible, setVisible] = useState(pageSize);
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(
    function observe() {
      if (!sentinelRef.current) return;
      const io = new IntersectionObserver(
        entries => {
          if (entries.some(e => e.isIntersecting)) {
            setVisible(v => Math.min(props.posts.length, v + pageSize));
          }
        },
        { rootMargin: "200px 0px" }
      );
      io.observe(sentinelRef.current);
      return () => io.disconnect();
    },
    [props.posts.length, pageSize]
  );

  const items = props.posts.slice(0, visible);

  return (
    <div>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {items.map(function r(p) {
          return <BlogPostCard key={p.id} post={p} />;
        })}
      </div>
      {visible < props.posts.length && (
        <div ref={sentinelRef} className="h-10" aria-hidden="true" />
      )}
    </div>
  );
}
